import dotenv from 'dotenv';
import type { BotDetectionConfig } from '../types/index.js';

dotenv.config();

export interface PODxConfig {
    x: {
        username: string;
        password: string;
        email?: string;
    };
    scraper: {
        targetUsername: string;
        maxTweets: number;
    };
    botDetection: BotDetectionConfig;
    analysis: {
        sentimentThreshold: number;
        enableBotDetection: boolean;
        enableReplyAnalysis: boolean;
        enableCoordinatedDetection: boolean;
        minConfidenceThreshold: number;
    };
}

export const config: PODxConfig = {
    x: {
        username: process.env.XSERVE_USERNAME || '',
        password: process.env.XSERVE_PASSWORD || '',
        ...(process.env.XSERVE_EMAIL ? { email: process.env.XSERVE_EMAIL } : {}),
    },
    scraper: {
        targetUsername: process.env.TARGET_USERNAME || 'pmarca',
        maxTweets: parseInt(process.env.MAX_TWEETS || '1000', 10),
    },
    botDetection: {
        genericityThreshold: parseFloat(process.env.BOT_GENERICITY_THRESHOLD || '0.7'),
        spamProbabilityThreshold: parseFloat(process.env.BOT_SPAM_THRESHOLD || '0.6'),
        coordinatedActivityThreshold: parseFloat(process.env.BOT_COORDINATED_THRESHOLD || '0.8'),
        replyFarmMinAccounts: parseInt(process.env.BOT_REPLY_FARM_MIN_ACCOUNTS || '3', 10),
        similarityThreshold: parseFloat(process.env.BOT_SIMILARITY_THRESHOLD || '0.8'),
        suspiciousNetworkConfidence: parseFloat(process.env.BOT_NETWORK_CONFIDENCE || '0.7'),
        timeWindowMinutes: parseInt(process.env.BOT_TIME_WINDOW_MINUTES || '60', 10),
        minRepliesForAnalysis: parseInt(process.env.BOT_MIN_REPLIES_ANALYSIS || '5', 10),
    },
    analysis: {
        sentimentThreshold: parseFloat(process.env.SENTIMENT_THRESHOLD || '0.7'),
        enableBotDetection: process.env.ENABLE_BOT_DETECTION === 'true',
        enableReplyAnalysis: process.env.ENABLE_REPLY_ANALYSIS !== 'false', // Default true
        enableCoordinatedDetection: process.env.ENABLE_COORDINATED_DETECTION !== 'false', // Default true
        minConfidenceThreshold: parseFloat(process.env.MIN_CONFIDENCE_THRESHOLD || '0.5'),
    },
};
